import React from 'react';

import { Box, Typography, useTheme } from '@mui/joy';

import Arrow from '../../assets/images/Arrow.svg?react';

interface CollapseProps {
  children: React.ReactElement;
  title?: string;
  collapseId: string;
  isOpen: boolean;
  onToggle: () => void;
}

const Collapse: React.FC<CollapseProps> = ({ children, title, collapseId, isOpen, onToggle }) => {
  const theme = useTheme();
  const typographyStyle = {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.5',
    height: '1.3125rem',
    letterSpacing: '0px',
    flex: 'none',
    order: 3,
    flexGrow: 1
  };

  return (
    <Box
      className='flex flex-col py-2 rounded-lg gap-2 min-h-max'
      sx={{
        border: 1,
        borderColor: 'primary.bbYellow'
      }}
    >
      <Box className='flex flex-row justify-start items-center px-3 gap-3 cursor-pointer' onClick={onToggle}>
        <Arrow
          className='w-4 h-4'
          fill={theme.palette.primary.bbYellow}
          style={{ rotate: isOpen ? '180deg' : '0deg' }}
        />
        {title && (
          <Typography
            level='body-lg'
            sx={{
              ...typographyStyle,
              color: 'primary.bbYellow',
              fontWeight: 600,
              minWidth: 'max-content'
            }}
          >
            {title}
          </Typography>
        )}
      </Box>
      {isOpen && children}
    </Box>
  );
};

export default Collapse;
